import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn, getInitials } from '@/lib/utils';
import { QuestionDetailResponse } from '@/types/api/question';
import { formatDistanceToNow } from 'date-fns';

interface AvatarAndCreatedAt {
  user?: QuestionDetailResponse['data']['author'];
  createdDate: string;
  isAnonymous?: boolean;
  avatarClassName?: string;
  userClassName?: string;
}

export function AvatarAndCreatedAt({
  user,
  createdDate,
  isAnonymous,
  avatarClassName,
  userClassName,
}: AvatarAndCreatedAt) {
  const displayName = isAnonymous
    ? 'Anonymous'
    : user?.fullName || user?.userName || user?.email || 'Unknown';

  return (
    <div className="flex items-start justify-between">
      <div className="flex items-center gap-2">
        <Avatar className={cn('h-9 w-9', avatarClassName)}>
          <AvatarImage src={isAnonymous ? '/anonymous.svg' : user?.avatarUrl} />
          <AvatarFallback className="uppercase">
            {getInitials(displayName, isAnonymous)}
          </AvatarFallback>
        </Avatar>

        <div className={cn('flex flex-col gap-0.5', userClassName)}>
          <div className="tracked-tight text-[#24292E] text-xs">
            {displayName}
          </div>
          {createdDate && (
            <p className="text-[10px] text-[#959DA5] font-normal">
              {userClassName ? ' • ' : ''}
              Posted{' '}
              {formatDistanceToNow(new Date(createdDate), {
                addSuffix: true,
              })}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
